__turbopack_context__.v({
  "fadeIn": "styles-module__av2rHa__fadeIn",
  "placeholder": "styles-module__av2rHa__placeholder",
  "searchBarWrapper": "styles-module__av2rHa__searchBarWrapper",
  "stickyMobileSearchBar": "styles-module__av2rHa__stickyMobileSearchBar",
});
